import { createFileRoute, redirect } from '@tanstack/react-router'

/** Seção sem tela própria: manda para a primeira tab. */
export const Route = createFileRoute('/_authed/contatos/')({
  beforeLoad: () => {
    // `to` com param: a rota é /contatos/$slug — os 4 tipos de contato são a
    // mesma entidade no backend, servidos por uma tela só.
    throw redirect({ to: '/contatos/$slug', params: { slug: 'clientes' } })
  },
})
